import { render, staticRenderFns } from "./fileDetai.vue?vue&type=template&id=751d060d&scoped=true&"
import script from "./fileDetai.vue?vue&type=script&lang=js&"
export * from "./fileDetai.vue?vue&type=script&lang=js&"
import style0 from "./fileDetai.vue?vue&type=style&index=0&id=751d060d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751d060d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/01-qym-hop-newmall-frontend-k8s@3/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('751d060d')) {
      api.createRecord('751d060d', component.options)
    } else {
      api.reload('751d060d', component.options)
    }
    module.hot.accept("./fileDetai.vue?vue&type=template&id=751d060d&scoped=true&", function () {
      api.rerender('751d060d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/components/fileDetai.vue"
export default component.exports